import { useNavigate } from 'react-router-dom';
import { LiaAngleRightSolid, LiaAngleLeftSolid } from 'react-icons/lia';
import i18n from 'i18next';
import './Topbar.css';

function Topbar({ 
  title = "", 
  headerLeft,
  showBackButton = true 
}) {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="topbar">
      <div className="topbar-right">
        {showBackButton && (
          <button
            onClick={handleBackClick}
            className="topbar-back-button"
          >
            {i18n.language === 'ar' ? (
              <LiaAngleRightSolid size={24} />
            ) : (
              <LiaAngleLeftSolid size={24} />
            )}
          </button>
        )}
      </div>

      <div className="topbar-title">
        {title}
      </div>

      <div className="topbar-left">
        {headerLeft}
      </div>
    </div>
  );
}

export default Topbar;